import React from "react";

const LazyBoardsAll = React.lazy(() => import("./BoardsAll").then((m) => ({ default: m.BoardsAll })));

export default LazyBoardsAll;
